
import { Box, Button, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { CommomProps } from "./types";
import { useTranslation } from "react-i18next";
import { icons } from "../../../../../../../../../../utils/icons";
import { VIEW_TYPES } from "../../../../types/ViewTypes";
import { Status } from "../../../../../../../../../../utils/enums";
import LightBulb from '../../../../../../../../../../assets/svg/mdi_lightbulb-on.svg'
import { CustomPaper } from "../../../../../../../../../../components/CustomPaper";
import { AnswerItemsHistoria } from "../../../../types";
import { ManageQuote } from "../ManageQuote";
import { useStyles } from "./styles";


export const ManageQuoteList = ({ onAttend, items, disabled, isMosaico, key, left, list, position, reload, setCurrentDataSolution, isList, setIsList }: CommomProps) => {

    const { t } = useTranslation()
    const styles = useStyles();

    const lastQuote = items[0];
    const isApproved = lastQuote?.statusIdAnswer === Status.APPROVED;
    const isRejected = lastQuote?.statusIdAnswer === Status.REJECTED && lastQuote.commentApprovalAnswer == null;
    const isIntructionComment = !!lastQuote.instructionSubmitted;

    const itemsChildren = lastQuote.answers.map((item: AnswerItemsHistoria) => ({
        answerSubmitted: lastQuote.answerSubmitted,
        instructionSubmitted: lastQuote.instructionSubmitted,
        instruction: lastQuote.instruction,
        statusIdAnswer: item.statusId,
        evidencesAnswer: item.evidences,
        evidencesRejectionAnswer: item.evidencesRejection,
        statusId: item.statusId,
        commentApprovalAnswer: item.commentApproval,
        evidencesApprovalAnswer: item.evidencesApproval,
        commentApprovalQuote: lastQuote.commentApprovalQuote,
        reasonOfRejectionQuote: lastQuote.reasonOfRejectionQuote,
        evidencesQuote: lastQuote.evidencesQuote,
        commentUpload: lastQuote.commentUpload,
        dateRequestManagement: lastQuote.dateRequestManagement,
        dateUploadQuote: lastQuote.dateUploadQuote,
        dateUploadSolution: item.createTime,
        newStep: lastQuote.newStep,
        idQuote: lastQuote.idQuote,
        type: lastQuote.type,
        usersAssings: lastQuote.usersAssings,
        descriptionAnswer: item.description,
        userUploadAnswer: lastQuote.userUploadAnswer,
        reasonOfRejectionAnswer: item.reasonOfRejection,
        userReviewerAnswer: lastQuote.answer?.reviewerUser,
        dateRequestCreateFolio: lastQuote.dateRequestCreateFolio
    }))

    return (
        <Box>
            <Box sx={styles.containerHeader}>
                <Box sx={styles.dFlex}>
                    <Box sx={styles.bulb}>
                        <LightBulb/>
                    </Box>
                    <Typography sx={styles.title}>{t(`reportFolio.detail.general.${isIntructionComment ? 'userCreatorSolutions' : 'userAssignedSolutions'}`)}</Typography>
                </Box>

                <Box sx={styles.fx}>
                    <Tooltip title={t('reportFolio.buttons.mosaico')}>
                        <IconButton sx={styles.add(isList)} onClick={() => { setIsList(false) }}>
                            {icons('mosaic')}
                        </IconButton>
                    </Tooltip>

                    <Tooltip title={t('reportFolio.buttons.list')}>
                        <IconButton sx={styles.add(!isList)} onClick={() => { setIsList(true) }}>
                            {icons('list')}
                        </IconButton>
                    </Tooltip>

                    {!isApproved && !isRejected &&
                        <Box sx={styles.containerButtons}>
                            <Button
                                variant="contained"
                                sx={{ backgroundColor: "#EC6666" }}
                                onClick={() => {
                                    onAttend({
                                        type: VIEW_TYPES.SOLUTION_FORM,
                                        action: 'reject'
                                    })
                                }}
                                disabled={disabled}
                            >
                                {t("reportFolio.detail.general.rejectSolution")}
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    onAttend({
                                        type: VIEW_TYPES.SOLUTION_FORM,
                                        action: 'approve'
                                    })
                                }}
                                disabled={disabled}
                            >
                                {t("reportFolio.detail.general.approveSolution")}
                            </Button>
                        </Box>
                    }
                </Box>
            </Box>

            <CustomPaper elevation={3} sx={styles.paperC}>
                <Grid container spacing={3}>
                    {itemsChildren.map((children: any, index: number) => (
                        <Grid key={children.id} item xl={isList ? 12 : 6} lg={isList ? 12 : 6} md={12} sm={12} xs={12}>
                            <ManageQuote
                                setCurrentDataSolution={setCurrentDataSolution}
                                disabled={disabled}
                                isMosaico={!isList}
                                items={[children]}
                                left={left}
                                list={true}
                                onAttend={onAttend}
                                position={index + 1}
                                reload={reload}
                                key={key}
                            />
                        </Grid>
                    ))}
                </Grid>
            </CustomPaper>
        </Box>
    );
};
